import { AddNewProfParamsForm } from '../../types/user/prof.def';
import { ID } from '../../types/typeDef';
import { PROF_ID } from './authorization';

//TODO réparer l'obligation d'envoyer ces donnés au back
export const addProfParams = (data: AddNewProfParamsForm, maClasse: ID) => {
  return {
    ...data,
    username: 'username',
    password: 'password',
    classes: maClasse,
    role: PROF_ID,
    isPairTeacher: true,
    blocked: true
  };
};
